import { render, staticRenderFns } from "./AccountsSetup.vue?vue&type=template&id=75dab457&scoped=true&"
import script from "./AccountsSetup.vue?vue&type=script&lang=js&"
export * from "./AccountsSetup.vue?vue&type=script&lang=js&"
import style0 from "./AccountsSetup.vue?vue&type=style&index=0&id=75dab457&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75dab457",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('75dab457')) {
      api.createRecord('75dab457', component.options)
    } else {
      api.reload('75dab457', component.options)
    }
    module.hot.accept("./AccountsSetup.vue?vue&type=template&id=75dab457&scoped=true&", function () {
      api.rerender('75dab457', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/monbi/partners/AccountsSetup.vue"
export default component.exports